// @vendors
import { useState, useMemo } from 'react';

// @material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from '@mui/material';

// @assets
import { DialogNewTargetStyle} from '../../../../assets/css/payroll-style'

const INITIAL_STATE = {
  targetGroup: '',
  code: '',
  flag: '',
  maxCredit: '',
  maxWage: '',
};
 
const DialogNewTargetGroup = ({ open, onClose, onCreate }) => {
  const [newTarget, setNewTarget] = useState(INITIAL_STATE);
  const style = useMemo(() => DialogNewTargetStyle(), []);
  const [touched, setTouched] = useState({ targetGroup: false, code: false, maxCredit:false, maxWage:false });
 
  const handleChange = (field) => (e) => {
    setNewTarget((prev) => ({ ...prev, [field]: e.target.value }));
  };
 
  const handleSave = async () => {
    const payload = {
      ...newTarget,
      code: newTarget.code.toUpperCase(),
      flag: newTarget.flag || newTarget.targetGroup,
      maxCredit: newTarget.maxCredit === '' ? 0 : Number(newTarget.maxCredit),
      maxWage:   newTarget.maxWage   === '' ? 0 : Number(newTarget.maxWage),
    };
    const success = await onCreate(payload);
    if (success) {
      setNewTarget(INITIAL_STATE);
      setTouched({ targetGroup: false, code: false, maxCredit: false, maxWage: false })
    }
  };
 
  const handleClose = () => {
    setNewTarget(INITIAL_STATE);
    setTouched({ targetGroup: false, code: false, maxCredit: false, maxWage: false })
    onClose();
  };
 
  const isDisabled = !newTarget.targetGroup || !newTarget.code ||  !newTarget.maxCredit || !newTarget.maxWage;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth sx={style.dialog}>
        <DialogTitle sx={style.title}>New Target</DialogTitle>

        <DialogContent sx={style.content}>
            <TextField
                label="Target"
                value={newTarget.targetGroup}
                onChange={handleChange('targetGroup')}
                sx={style.fieldInput}
                onBlur={() => setTouched((prev) => ({ ...prev, targetGroup: true }))}
                error={touched.targetGroup && !newTarget.targetGroup}
                fullWidth
                required
            />
            <TextField
                label="Code"
                value={newTarget.code}
                onChange={handleChange('code')}
                sx={style.fieldInput}
                onBlur={() => setTouched((prev) => ({ ...prev, code: true }))}
                error={touched.code && !newTarget.code}
                fullWidth
                required
            />
            <TextField
                label="Flag"
                value={newTarget.flag}
                onChange={handleChange('flag')}
                sx={style.fieldInput}
                fullWidth
            />
            <TextField
                label="Max Credit"
                type="number"
                value={newTarget.maxCredit}
                onChange={handleChange('maxCredit')}
                inputProps={{ min: 0 }}
                onBlur={() => setTouched((prev) => ({ ...prev, maxCredit: true }))}
                error={touched.maxCredit && (!newTarget.maxCredit || Number(newTarget.maxCredit) <= 0)}
                helperText={
                    touched.maxCredit && (!newTarget.maxCredit || Number(newTarget.maxCredit) <= 0)
                    ? 'Must be greater than 0'
                    : ''
                }
                sx={style.fieldInput}
                fullWidth
                required
            />
            <TextField
                label="Max Wage"
                type="number"
                value={newTarget.maxWage}
                onChange={handleChange('maxWage')}
                inputProps={{ min: 0 }}
                onBlur={() => setTouched((prev) => ({ ...prev, maxWage: true }))}
                error={touched.maxWage && (!newTarget.maxWage || Number(newTarget.maxWage) <= 0)}
                helperText={
                    touched.maxWage && (!newTarget.maxWage || Number(newTarget.maxWage) <= 0)
                    ? 'Must be greater than 0'
                    : ''
                }
                sx={style.fieldInput}
                fullWidth
                required
            />
        </DialogContent>

        <DialogActions sx={style.divActions}>
            <Button onClick={handleClose} sx={style.buttonCancel}>
                Cancel
            </Button>
            <Button onClick={handleSave} sx={style.buttonSave} disabled={isDisabled}>
                Save
            </Button>
        </DialogActions>
    </Dialog>
    );
};

export default DialogNewTargetGroup;